import React from 'react';
import './Rehome.css';

const Rehome = () => {
  return (
    <div className="rehome-page">
      <div className="page-header">
        <h1>🏠 Rehome a Pet</h1>
        <p>Find a loving new home for your pet</p>
      </div>

      <div className="rehome-info">
        <div className="info-card">
          <span className="info-icon">📝</span>
          <h3>List Your Pet</h3>
          <p>Create a detailed profile with photos and information about your pet</p>
        </div>
        <div className="info-card">
          <span className="info-icon">🔍</span>
          <h3>Find Perfect Match</h3>
          <p>We'll help you find the right family for your beloved companion</p>
        </div>
        <div className="info-card">
          <span className="info-icon">✅</span>
          <h3>Safe Transfer</h3>
          <p>Complete the adoption process safely with our guidance</p>
        </div>
      </div>

      <div className="rehome-form-container">
        <h2>Submit Rehoming Request</h2>
        <form className="rehome-form">
          <div className="form-row">
            <div className="form-group">
              <label>Pet Name *</label>
              <input type="text" placeholder="Enter pet's name" required />
            </div>
            <div className="form-group">
              <label>Pet Type *</label>
              <select required>
                <option value="">Select type</option>
                <option value="dog">Dog</option>
                <option value="cat">Cat</option>
                <option value="rabbit">Rabbit</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Breed *</label>
              <input type="text" placeholder="Enter breed" required />
            </div>
            <div className="form-group">
              <label>Age *</label>
              <input type="text" placeholder="e.g., 2 years" required />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Gender *</label>
              <select required>
                <option value="">Select gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>
            <div className="form-group">
              <label>Location *</label>
              <input type="text" placeholder="City, State" required />
            </div>
          </div>

          <div className="form-group full-width">
            <label>Description *</label>
            <textarea 
              rows="5" 
              placeholder="Tell us about your pet's personality, health, training, and reason for rehoming..."
              required
            ></textarea>
          </div>

          <div className="form-group full-width">
            <label>Upload Photos</label>
            <div className="file-upload">
              <input type="file" multiple accept="image/*" />
              <span className="upload-text">📸 Click to upload or drag and drop</span>
            </div>
          </div>

          <div className="form-group full-width">
            <label>Contact Information *</label>
            <input type="text" placeholder="Your name" required />
            <input type="email" placeholder="Email address" required style={{marginTop: '10px'}} />
            <input type="tel" placeholder="Phone number" required style={{marginTop: '10px'}} />
          </div>

          <div className="checkbox-group">
            <label>
              <input type="checkbox" required />
              <span>I confirm that I am the legal owner of this pet and have the right to rehome</span>
            </label>
          </div>

          <button type="submit" className="submit-btn">Submit Rehoming Request</button>
        </form>
      </div>
    </div>
  );
};

export default Rehome;
